import styled from '@emotion/styled'

import { ORGANIZATION_LOGO_AND_ICON_SECTIONS_HEIGHT } from '../../../../../../../../../OrganizationSettings/constants/organizationLogoAndIconSectionsHeight'

export const LogoWrapper = styled.div`
  height: ${ORGANIZATION_LOGO_AND_ICON_SECTIONS_HEIGHT}px;
`
